module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "content fs-32 color-666"
  }, [_vm._v("\n        这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容\n        这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容\n        这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容这是合约的内容\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group flex bd-top"
  }, [_c('div', {
    staticClass: "flex1 btn bg-fff color-000",
    on: {
      "click": function($event) {
        return _vm.agree(false)
      }
    }
  }, [_vm._v("不同意")]), _vm._v(" "), _c('div', {
    staticClass: "flex1 btn bg-main color-fff",
    on: {
      "click": function($event) {
        return _vm.agree(true)
      }
    }
  }, [_vm._v("同意")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69bb3a84","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/register/contract.vue
// module id = xAHx
// module chunks = 51